export default __webpack_public_path__ + "static/1785-f675ae4e32405cb7fe91d0ad57cfabd9.gif";